/* eslint-disable  react/display-name */
import {
  Grid,
  IconButton,
  Tooltip,
  Button,
  CircularProgress,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PText from "../../../components/pos/PText";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import PRSelect from "../../../components/pos/PRSelect";
import { StringUtils } from "../../../utils/StringUtils";
import PCheck from "../../../components/pos/PCheck";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import PConfirm from "../../../components/pos/PConfirm";

export default function JournalEntryCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);
  const [ledgerList, setLedgerList] = useState([]);
  const [ledgerListMaster, setLedgerListMaster] = useState([]);
  const [totalShippingCost, setTotalShippingCost] = useState(0);
  const [windowTitle, setWindowTitle] = useState("");
  const [mode, setMode] = useState("");
  const [journalEntryAdjustmentList, setJournalEntryAdjustmentlist] = useState(
    []
  );
  const [journalEntryDate, setJournalEntryDate] = useState("");
  const [journalEntryDateError, setJournalEntryDateError] = useState("");
  const [description, setDescription] = useState("");
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [code, setCode] = useState("");
  const [id, setId] = useState("");
  const [origObject, setOrigObject] = useState(null);
  const [saveClicked, setSaveClicked] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [getPrint, setGetPrint] = useState(false);

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    showCrud();
  }, []);

  function showCrud() {
    setWindowTitle(translate("NEW JOURNAL ENTRY"));
    setMode(props.mode);
    let d = new Date();
    d.setHours(d.getHours());
    d.setMinutes(d.getMinutes());
    d.setSeconds(d.getSeconds());
    setJournalEntryDate(d.toISOString());
    loadShippingCostLedgers();
    setDescription("");
    setCode("AUTO");
    setId("");
    setJournalEntryAdjustmentlist([
      {
        serialNumber: 1,
        accountLedger: null,
        creditAmount: "",
        debitAmount: "",
        narration: "",
        taxable: false,
      },
      {
        serialNumber: 2,
        accountLedger: null,
        creditAmount: "",
        debitAmount: "",
        narration: "",
        taxable: false,
      },
    ]);
  }

  useEffect(() => {
    if (props.selectedJournal) {
      populateManualJouralEntry(props.selectedJournal);
      if (props.viewOnlyForUpdate) {
        setMode("view");
      } else {
        setMode(props.mode);
      }
    }
  }, [props.selectedJournal]);

  useEffect(() => {
    let debit = 0;
    let credit = 0;
    for (let d of journalEntryAdjustmentList) {
      setTotalCredit(
        (debit = debit + parseFloat(d.debitAmount == 0 ? 0.0 : d.debitAmount))
      );
      setTotalDebit(
        (credit =
          credit + parseFloat(d.creditAmount == 0 ? 0.0 : d.creditAmount))
      );
    }
  }, [journalEntryAdjustmentList]);

  useEffect(() => {
    if (liveValidation && journalEntryDate === "")
      setJournalEntryDateError(translate("Date is Required"));
    else setJournalEntryDateError("");
  }, [journalEntryDate]);

  var biRef = {};

  async function loadShippingCostLedgers() {
    let ledgers = await API.get("/api/v1/ledgerlist");
    if (ledgers && ledgers.data) {
      let ledgerListTemp = [];
      ledgers.data.map((ledger) => {
        ledgerListTemp.push({
          name: ledger.name,
          label: ledger.name,
          id: ledger.id,
          code: ledger.code,
        });
      });
      setLedgerList(ledgerListTemp);
      setLedgerListMaster(ledgerListTemp);
    }
  }

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  function validate() {
    if (journalEntryDate === "") {
      setJournalEntryDateError(translate("Date is Required"));
      setLiveValidation(true);
      return false;
    }
    for (let i = 0; i < journalEntryAdjustmentList.length; i++) {
      if (journalEntryAdjustmentList[i].accountLedger == null) {
        props.showMessage(
          "error",
          translate("Please select Ledger for row") + ":" + (i + 1)
        );
        return false;
      }
      if (
        (journalEntryAdjustmentList[i].creditAmount == null ||
          journalEntryAdjustmentList[i].creditAmount == "") &&
        (journalEntryAdjustmentList[i].debitAmount == null ||
          journalEntryAdjustmentList[i].debitAmount == "")
      ) {
        props.showMessage(
          "error",
          translate("Debit/Credit amount can not be empty at row ") + (i + 1)
        );
        return false;
      }
      if (
        Number(journalEntryAdjustmentList[i].creditAmount > 0) &&
        journalEntryAdjustmentList[i].debitAmount > 0
      ) {
        props.showMessage(
          "error",
          translate("Both credit and debit entries are not allowed")
        );
        return false;
      }
    }
    if (totalCredit != totalDebit) {
      props.showMessage(
        "error",
        translate("Total Debit must be equal to total Credit!")
      );
      setLiveValidation(true);
      return false;
    }
    if (!journalEntryAdjustmentList.length > 0) {
      props.showMessage(
        "error",
        translate("Please add journal entry before proceed!")
      );
      return false;
    }

    return true;
  }

  async function populateManualJouralEntry(journalEntryId) {
    try {
      let { data } = await API.get(
        "/api/v1/accounting/journal/adjustment/" + journalEntryId
      );
      setOrigObject(data);
      populateData(data);
      props.setOpenWindow(true);
      setWindowTitle(data.code);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive Journal entry data from server")
      );
    }
  }

  function populateData(bean) {
    setCode(bean.code);
    setDescription(bean.description);
    setJournalEntryDate(bean.date);
    let entryList = [];
    let siNo = 1;
    bean.entryList.map((entry) => {
      entryList.push({
        serialNumber: siNo,
        accountLedger: {
          name: entry.accountName,
          label: entry.accountName,
          id: entry.accountId,
          code: entry.accountCode,
        },
        creditAmount: entry.creditAmount,
        debitAmount: entry.debitAmount,
        narration: entry.narration,
        taxable: entry.taxable,
      });
      siNo++;
    });
    setJournalEntryAdjustmentlist(entryList);
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function handleSave(print) {
    setSaveClicked(true);
    setGetPrint(print);
    if (validate()) {
      let saveObject = Object.create(null);
      saveObject["description"] = description;
      saveObject["date"] = journalEntryDate + " 00:00:00";
      saveObject["code"] = code;
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
      if (mode == "edit") {
        saveObject["intVersion"] = origObject.intVersion;
        saveObject["id"] = origObject.id;
      }
      saveObject["amount"] = totalCredit;
      let entryList = [];
      for (let i = 0; i < journalEntryAdjustmentList.length; i++) {
        let entryObject = Object.create(null);
        entryObject["taxable"] = journalEntryAdjustmentList[i].taxable;
        entryObject["accountId"] =
          journalEntryAdjustmentList[i].accountLedger.id;
        entryObject["accountCode"] =
          journalEntryAdjustmentList[i].accountLedger.code;
        entryObject["accountName"] =
          journalEntryAdjustmentList[i].accountLedger.name;
        if (
          journalEntryAdjustmentList[i].creditAmount != null &&
          journalEntryAdjustmentList[i].creditAmount != ""
        ) {
          entryObject["creditAmount"] =
            journalEntryAdjustmentList[i].creditAmount;
        } else {
          entryObject["creditAmount"] = 0;
        }
        if (
          journalEntryAdjustmentList[i].debitAmount != null &&
          journalEntryAdjustmentList[i].debitAmount != ""
        ) {
          entryObject["debitAmount"] =
            journalEntryAdjustmentList[i].debitAmount;
        } else {
          entryObject["debitAmount"] = 0;
        }
        entryObject["narration"] = journalEntryAdjustmentList[i].narration
          ? journalEntryAdjustmentList[i].narration
          : description;
        entryList.push(entryObject);
      }
      saveObject["entryList"] = entryList;
      try {
        showProgress(true, "Saving");
        let result = await API.post(
          "/api/v1/accounting/adjustment",
          saveObject
        );
        setCode(result.data.code);
        setId(result.data.id);
        props.refreshData();
        setMode(
          props.context.privileges.jv_update_update ||
            props.context.privileges.jv_update_delete
            ? "edit"
            : "view"
        );
        populateManualJouralEntry(result.data.id);
        if (getPrint) {
          let paramsList = [
            {
              key: "transactionId",
              value: result.data.id,
            },
          ];
          biRef.genericReportView.showGenericReportViewer(
            "reports/generic/Journal_entry",
            paramsList,
            "Accounts Transaction"
          );
        }
        showProgress(false, "Saving");
      } catch (err) {
        if (err.response && err.response.status == 412) {
          console.log(err.response);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Transactions")
          );
        }
      }
      props.showMessage("success", translate("Saved Successfully"));
    }
  }

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let journalEntryAdjustmentListTemp = [...journalEntryAdjustmentList];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < journalEntryAdjustmentListTemp.length; i++) {
      if (tableMeta.rowIndex != i) {
        journalEntryAdjustmentListTemp[i].serialNumber = index + 1;
        updatedList.push(journalEntryAdjustmentListTemp[i]);
        index++;
      }
    }
    setJournalEntryAdjustmentlist(updatedList);
  }

  function handleAddFileClick() {
    let journalEntryAdjustmentListTemp = [...journalEntryAdjustmentList];
    journalEntryAdjustmentListTemp.push({
      serialNumber: journalEntryAdjustmentListTemp.length + 1,
      accountLedger: null,
      creditAmount: "",
      debitAmount: "",
      narration: "",
    });
    setJournalEntryAdjustmentlist(journalEntryAdjustmentListTemp);
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 400,
  };

  function onNewClicked() {
    showCrud();
    setMode("create");
  }

  function handleAccountChange(newValue, tableMeta) {
    {
      let tempData = [...tableMeta.tableData];
      let ledgerListTemp = [...ledgerList];
      if (tempData[tableMeta.rowIndex].accountLedger)
        ledgerListTemp.push(tempData[tableMeta.rowIndex].accountLedger);
      let index = ledgerListTemp.indexOf(newValue);
      if (index > -1) {
        ledgerListTemp.splice(index, 1);
      }
      ledgerListTemp.sort(function (a, b) {
        return a.name.toLowerCase() < b.name.toLowerCase()
          ? -1
          : a.name.toLowerCase() > b.name.toLowerCase()
          ? 1
          : 0;
      });

      setLedgerList(ledgerListTemp);

      tempData[tableMeta.rowIndex].accountLedger = newValue;
      setJournalEntryAdjustmentlist(tempData);
    }
  }

  function getTotalDebit(data) {
    let total = 0;
    data.forEach((element) => {
      total += Number(element.debitAmount);
    });
    return total;
  }

  function getTotalCredit(data) {
    let total = 0;
    data.forEach((element) => {
      total += Number(element.creditAmount);
    });
    return total;
  }

  function findParent(code) {
    let parentCode = code.substring(0, 2);
    let parent = "";
    switch (parentCode) {
      case "01":
        parent = "Assets";
        break;
      case "02":
        parent = "Liability";
        break;
      case "03":
        parent = "Expense";
        break;
      case "04":
        parent = "Income";
        break;
      default:
        parent = "";
        break;
    }
    return parent;
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete Journal Entry ") +
        origObject.code +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete(
          "/api/v1/accounting/journal/adjustment/delete/" + origObject.id
        );
        props.showMessage(
          "warning",
          translate("Journal Entry ") + code + translate(" got Removed")
        );
        props.refreshData();
        onCloseWindow();
        props.setOpenWindow(false);
      } catch (err) {
        console.log(err);
        props.showMessage(
          "error",
          translate("Not able to Delete Journal Entry")
        );
      }
    }
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={8}>
            {option.name}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right", fontSize: 12 }}>
            {findParent(option.code)}
          </Grid>
        </Grid>
      );
    }
    if (!option.name) return "";
    return option.name;
  };

  const customFilterOption = (ledger, rawInput) => {
    
    if(rawInput){
      const inputValue = rawInput.toUpperCase();
      const label = ledger.label.toUpperCase();
      return label.startsWith(inputValue);
    }else{
      return true
    }
      };

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 8 }}>SN</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 15, width: 30 }}>{value}</div>
        ),
      },
    },
    {
      name: "accountLedger",
      label: translate("Ledger"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 450 }}>
            <PRSelect
              options={ledgerList}
              filterOption={customFilterOption}
              value={value}
              formatOptionLabel={formatOptionLabel}
              components={{ formatOptionLabel }}
              onChange={(newValue) => handleAccountChange(newValue, tableMeta)}
            ></PRSelect>   
          </div>
        ),
      },
    },
    {
      name: "narration",
      label: translate("Narration"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 150 }}>
            <PText
              value={value}
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].narration = e.target.value;
                setJournalEntryAdjustmentlist(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "debitAmount",
      label: translate("Debit"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 150 }}>
            <PText
              value={value}
              type="number"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].debitAmount = e.target.value;
                setJournalEntryAdjustmentlist(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "creditAmount",
      label: translate("Credit"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 150 }}>
            <PText
              value={value}
              type="number"
              onChange={(e) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].creditAmount = e.target.value;
                setJournalEntryAdjustmentlist(tempData);
              }}
            ></PText>
          </div>
        ),
      },
    },

    {
      name: "taxable",
      label: translate("Taxable"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 15, width: 15 }}>
            <PCheck
              onChange={(value) => {
                let tempData = [...tableMeta.tableData];
                tempData[tableMeta.rowIndex].taxable = value;
                setJournalEntryAdjustmentlist(tempData);
              }}
              checked={value}
              label={""}
            ></PCheck>
            {value}
          </div>
        ),
      },
    },

    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td align="right">Action</td>
                  <td align="right">
                    <Tooltip title={"Add new row"}>
                      <IconButton
                        color="secondary"
                        onClick={handleAddFileClick}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  const content = (
    <div>
      <Grid container>
        <Grid
          item
          xs={2}
          sm={1}
          style={{
            paddingLeft: "25px",
            paddingTop: "10px",
            paddingBottom: "20px",
          }}
        >
          Code
        </Grid>
        <Grid item xs={2} sm={1} style={{ paddingTop: "8px" }}>
          <PText
            value={code}
            type="text"
            onChange={(e) => {
              setCode(e.target.value);
            }}
            InputProps={{ readOnly: true }}
          ></PText>
        </Grid>
        <Grid
          item
          xs={2}
          sm={1}
          style={{ paddingTop: "10px", paddingLeft: "20px" }}
        >
          Date
        </Grid>
        <Grid item xs={2} sm={2} style={{ paddingTop: "8px" }}>
          <PDatePicker
            value={journalEntryDate}
            type="date"
            error={journalEntryDateError}
            onChange={(e) => {
              let d = new Date();
              e.$d.setHours(d.getHours());
              e.$d.setMinutes(d.getMinutes());
              e.$d.setSeconds(d.getSeconds());
              setJournalEntryDate(e.$d.toISOString());
            }}
          ></PDatePicker>
        </Grid>
        <Grid
          item
          xs={2}
          sm={2}
          style={{ paddingLeft: "25px", paddingTop: "10px" }}
        >
          Description
        </Grid>
        <Grid item xs={6} sm={5} style={{ paddingTop: "8px" }}>
          <PText
            value={description}
            type="text"
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          ></PText>
        </Grid>
        <Grid item xs={12} sm={12}>
          <MUIDataTable
            data={journalEntryAdjustmentList}
            columns={columns}
            options={options}
          />
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          style={{ paddingLeft: "25px", paddingTop: "8px" }}
        >
          <b>Total Credit</b>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          style={{
            paddingLeft: "25px",
            paddingTop: "8px",
            fontWeight: "bold",
            color:
              saveClicked && Number(totalCredit) != Number(totalDebit)
                ? "red"
                : "black",
          }}
        >
          {StringUtils.formattedNumber(
            totalCredit,
            props.context.store.currencyDecimal
          )}
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          style={{ paddingLeft: "25px", paddingTop: "8px" }}
        >
          <b>Total Debit</b>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          style={{
            paddingLeft: "25px",
            paddingTop: "8px",
            fontWeight: "bold",
            color:
              saveClicked && Number(totalCredit) != Number(totalDebit)
                ? "red"
                : "black",
          }}
        >
          {StringUtils.formattedNumber(
            totalDebit,
            props.context.store.currencyDecimal
          )}
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      <PDialog
        content={content}
        title={windowTitle}
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={() => handleSave(false)}
        onPrint={() => handleSave(true)}
        hideSave={
          (!props.context.privileges.jv_update_update &&
            props.context.privileges.jv_update_delete) ||
          mode === "view"
            ? mode === "create"
              ? false
              : true
            : false
        }
        showPrint={
          (!props.context.privileges.jv_update_update &&
            props.context.privileges.jv_update_delete) ||
          mode === "view"
            ? mode === "create"
              ? true
              : false
            : true
        }
        mode={mode}
        onDelete={props.context.privileges.jv_update_delete ? onDelete : false}
        showNew={props.readOnly ? false : mode != "create" ? true : false}
        onNewClicked={onNewClicked}
      ></PDialog>

      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
